import {MetricsSection} from '/constant/TestIDs';
import {BUSINESS_COACH, BUSINESS_LEADER} from '/enum/competency.enum';
import {
  REPORT_ALL_FRONTLINE_CLIENTS,
  REPORT_ALL_GEN0_CLIENTS,
  REPORT_ALL_ORGANIZATION_CLIENTS,
  REPORT_NEW_FRONTLINE_CLIENTS,
  REPORT_NEW_GEN0_CLIENTS,
  REPORT_NEW_ORGANIZATION_CLIENTS,
} from '/enum/records.enum';

export function getListItems({
  clientsCountFrontline,
  clientsCountGen0,
  clientsCountOrg,
  currentUserCompetency,
  newClientsCountFrontline,
  newClientsCountGen0,
  newClientsCountOrg,
  tt,
}: any) {
  const listItems = [
    {
      label: tt('new.frontline', 'New Frontline Clients'),
      value: newClientsCountFrontline,
      recordsName: REPORT_NEW_FRONTLINE_CLIENTS,
      testID: MetricsSection.metricNewFrontlineClients,
    },
    {
      label: tt('total.frontline', 'All Frontline Clients'),
      value: clientsCountFrontline,
      recordsName: REPORT_ALL_FRONTLINE_CLIENTS,
      testID: MetricsSection.metricAllFrontlineClients,
    },
  ];

  if (
    currentUserCompetency === BUSINESS_COACH ||
    currentUserCompetency === BUSINESS_LEADER
  ) {
    listItems.push({
      label: tt('new.gen0', 'New Generation 0 Clients'),
      value: newClientsCountGen0,
      recordsName: REPORT_NEW_GEN0_CLIENTS,
      testID: MetricsSection.metricNewGeneration0Clients,
    });
    listItems.push({
      label: tt('total.gen0', 'All Generation 0 Clients'),
      value: clientsCountGen0,
      recordsName: REPORT_ALL_GEN0_CLIENTS,
      testID: MetricsSection.metricAllGeneration0Clients,
    });
  }

  if (currentUserCompetency === BUSINESS_LEADER) {
    listItems.push({
      label: tt('new.org', 'New Organization Clients'),
      value: newClientsCountOrg,
      recordsName: REPORT_NEW_ORGANIZATION_CLIENTS,
      testID: MetricsSection.metricNewOrganizationClients,
    });
    listItems.push({
      label: tt('total.org', 'All Organization Clients'),
      value: clientsCountOrg,
      recordsName: REPORT_ALL_ORGANIZATION_CLIENTS,
      testID: MetricsSection.metricAllOrganizationClients,
    });
  }

  return listItems;
}
